import React from 'react';
import { useField } from 'react-final-form';

import { QuestionChoice, questionResponseProperty, QuestionType, YesNoChoice } from 'types/Question';

import YesNoCardActions from './YesNoCardActions';
import SingleChoiceCardActions from './SingleChoiceCardActions';
import MultipleChoiceCardActions from './MultipleChoiceCardActions';

interface CardActionsProps {
  name: string;
}

const YesNoCard: React.FC<CardActionsProps> = ({ name }) => {
  const { value, onChange } = useField<YesNoChoice>(`${name}.${questionResponseProperty[QuestionType.YES_NO]}`, { subscription: { value: true } }).input;
  return <YesNoCardActions onChange={onChange} value={value} />;
};

const SingleChoiceCard: React.FC<CardActionsProps> = ({ name }) => {
  const { value: choices } = useField<QuestionChoice[]>(`${name}.choices`, { subscription: { value: true } }).input;
  const { value, onChange } = useField<string>(`${name}.${questionResponseProperty[QuestionType.SINGLE_CHOICE]}`, { subscription: { value: true } }).input;
  return <SingleChoiceCardActions choices={choices} value={value} onChange={onChange} />;
};

const MultiChoiceCard: React.FC<CardActionsProps> = ({ name }) => {
  const { value: choices } = useField<QuestionChoice[]>(`${name}.choices`, { subscription: { value: true } }).input;
  const { value, onChange } = useField<string[]>(`${name}.${questionResponseProperty[QuestionType.MULTIPLE_CHOICE]}`, { subscription: { value: true } }).input;
  return <MultipleChoiceCardActions choices={choices} value={value} onChange={onChange} />;
};

const COMPONENT_BY_TYPE: Record<QuestionType, React.FC<CardActionsProps>> = {
  [QuestionType.YES_NO]: YesNoCard,
  [QuestionType.MULTIPLE_CHOICE]: MultiChoiceCard,
  [QuestionType.SINGLE_CHOICE]: SingleChoiceCard,
  [QuestionType.INFORMATION]: () => null,
};

const CardActions: React.FC<CardActionsProps> = ({ name }) => {
  const { value: type } = useField<QuestionType>(`${name}.type`, { subscription: { value: true } }).input;
  const Component = COMPONENT_BY_TYPE[type];
  return Component && <Component name={name} />;
};

export default CardActions;
